import { getCities, getContext } from "./context";
import { createTransaction } from "./createTransaction";
import { getSignatureLink } from "./getSignatureLink";
import { postAuthorization } from "./postAuthorization";
import { postPreAnalysis } from "./postPreAnalysis";
import { postSimulation } from "./postSimulation";
import { putSelectProduct } from "./putSelectProduct";

export const crefazCltService = {
  postPreAnalysis,
  postAuthorization,
  postSimulation,
  putSelectProduct,
  createTransaction,
  getSignatureLink,
  getContext,
  getCities,
};
